<div class='p-fluid'>
  <div>{{loginPageService.mfaMessage}}</div>
  <span class="p-float-label mt-3">
    <input
      type='text'
      pInputText
      [(ngModel)]='inputValue'
      [ngClass]='{"p-invalid": invalid}'
      (keyup.enter)='onConfirm()'
      autofocus
    />
    <label>MFA Token</label>
  </span>
  <small class='p-invalid' *ngIf='invalid'>{{ errorMessage }}</small>
  <small class="text-success" *ngIf="emailCodeSent">
    Code sent to your email. Please check your inbox.
  </small>
</div>

<div class='p-fluid mt-3'>
  <app-suspense-button label='Confirm' [loading]='loading' (buttonClick)='onConfirm()'></app-suspense-button>
  <button 
    type="button" 
    pButton 
    class="p-button-outlined p-button-secondary mt-2 w-100" 
    label="Send code to email instead" 
    (click)="sendCodeToEmail()" 
    *ngIf="!emailCodeSent">
  </button>
</div>
